(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-subscription-buttons"] && !Shopify.designMode) return;
  try {
    
  fetch('/cart/clear');
  document.addEventListener('DOMContentLoaded', function () {
    let loading = false;
    const forms = Array.from(document.querySelectorAll('[data-subscription-form]'));

    forms.forEach((form, index) => {
      const selector = form.getAttribute('data-trigger-selector');
      if (!selector) return;

      const trigger = document.querySelector(selector);
      if (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (loading) return;
          loading = true;
          form.submit();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
